(() => {
  const selectCreditcard = '.select-customer-creditcard'
  const selectOtherThanCreditcard = '.select-customer-other-than-creditcard'
  const selectRegisteredCreditcard = '.select-customer-registered-creditcard'

  const creditcardForm = '.customer_creditcard_form'
  const registeredCreditcardInfo = '.customer_registered_creditcard_info'
  const eventPaymentNewPath = process.env.JS_BASE_URL + 'customer/event/payment/new'

  const init = () => {
    if (!$(selectCreditcard).prop('checked')) {
      $(creditcardForm).hide();
    }
    if (!$(selectRegisteredCreditcard).prop('checked')) {
      $(registeredCreditcardInfo).hide();
    }
    $('body')
      .on('click', selectCreditcard, showCreditcardForm)
      .on('click', selectOtherThanCreditcard, hideCreditcardForm)
      .on('click', selectRegisteredCreditcard, showRegisteredCreditcardInfo);
  }

  const showCreditcardForm = () => {
    $(creditcardForm).slideDown();
    $(registeredCreditcardInfo).slideUp();
  }

  const hideCreditcardForm = () => {
    $(creditcardForm).slideUp();
    $(registeredCreditcardInfo).slideUp();
  }

  const showRegisteredCreditcardInfo = () => {
    $(registeredCreditcardInfo).slideDown();
    $(creditcardForm).slideUp();
  }
  $(init);
})();

